import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { slideToggle } from "./../../composables/slideToggle.js";
import { Icon } from "@iconify/react";
import { AppSettings } from "./../../config/app-settings.js";
import PerfectScrollbar from "react-perfect-scrollbar";
import Swal from "sweetalert2";
import { registrarLogoutAuditoria } from "./../../pages/babilonia/auditoria-tracker.js";

function Header() {
  const [showPasswordModal, setShowPasswordModal] = useState(false); //modal para configurar contraseña
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);

  const [formData, setFormData] = useState({
    contrasena_actual: "",
    contrasena: "",
    confirmar_contrasena: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    const { contrasena, confirmar_contrasena, contrasena_actual } = formData;
    const accessToken =
      "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3"; // El token de acceso

    if (contrasena !== confirmar_contrasena) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Las contraseñas no coinciden",
      });
      return;
    }

    try {
      // Llamada al backend
      const response = await fetch(
        "https://api.checkmark.mx/financiamiento/update-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            correo: userEmail,
            contrasena: contrasena,
            contrasena_actual: contrasena_actual,
            access_token: accessToken,
          }),
        },
      );

      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "¡Éxito!",
          text: data.message || "Contraseña actualizada correctamente",
        });
        setFormData({
          contrasena: "",
          confirmar_contrasena: "",
          contrasena_actual: "",
        });
        setShowPasswordModal(false);
      } else {
        Swal.fire({
          icon: "error",
          title: data.error?.type || "Error",
          text:
            data.error?.description || "No se pudo actualizar la contraseña",
        });
      }
    } catch (error) {
      console.error("Error en la petición:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error de conexión con el servidor",
      });
    }
  };

  const isFormValid =
    formData.contrasena.trim() !== "" &&
    formData.confirmar_contrasena.trim() !== "";

  const { setAppSidebarCollapsed, setAppSidebarMobileToggled } =
    useContext(AppSettings);

  const { appThemePanelToggled, setAppThemePanelToggled } =
    useContext(AppSettings);

  const navigate = useNavigate(); // Usamos useNavigate para redirigir al login

  const handleLogout = () => {
    console.log("Cerrando sesión...");
    // Auditoría: se registra ANTES de borrar userId/accessToken
    registrarLogoutAuditoria();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("modulos");
    // Redirigir al login
    navigate("/", { replace: true });
  };

  // Obtén el correo del usuario desde localStorage
  const userEmail = localStorage.getItem("userEmail") || "USERNAME@GMAIL.COM"; // Valor por defecto si no hay sesión

  const userData = {
    img: "/assets/img/user/profile.jpg",
    name: userEmail, // Utiliza el correo obtenido
  };
  const chatData = [
    {
      msg: ["Hey, I'm testing out group messaging."],
      name: "Roberto Lambert",
      img: "/assets/img/user/user-2.jpg",
    },
    { msg: ["Cool"], reply: true, time: "Read 16:26" },
    { date: "Today 14:21" },
    {
      msg: ["Awesome! What's new?"],
      name: "Rick Powell",
      img: "/assets/img/user/user-3.jpg",
    },
    {
      msg: [
        "Not much, It's got a new look, contact pics show up in group messaging, some other small stuff.",
        "How's crusty old iOS 6 treating you?",
      ],
      name: "Roberto Lambert",
      img: "/assets/img/user/user-2.jpg",
    },
    { msg: ["Sucks"], reply: true, time: "Read 16:30" },
  ];
  const calendarData = [
    {
      date: "TODAY, NOV 4",
      list: [
        {
          time_start: "09:00",
          time_end: "12:00",
          color: "bg-success",
          title: "Meeting with HR",
          desc: ["Conference Room"],
        },
        {
          time_start: "20:00",
          time_end: "23:00",
          color: "bg-primary",
          title: "Dinner with Richard",
          desc: ["Tom's Too Restaurant"],
          contact: [
            {
              name: "Richard Leong",
              img: "/assets/img/user/user-3.jpg",
              link: "#",
            },
          ],
        },
      ],
    },
    {
      date: "TOMORROW, NOV 5",
      list: [
        {
          time_start: "All day",
          color: "bg-gray-300",
          title: "Terry Birthday",
        },
        { time_start: "08:00", color: "bg-gray-300", title: "Meeting" },
        {
          time_start: "00:00",
          time_end: "00:30",
          color: "bg-gray-300",
          title: "Server Maintenance",
          desc: ["Data Centre"],
        },
      ],
    },
  ];
  const notificationData = [
    {
      icon: "material-symbols-light:mark-email-unread-outline-sharp",
      title: "New email received",
      desc: "You have a new email from John Doe.",
      time: "2 minutes ago",
    },
    {
      icon: "material-symbols-light:calendar-clock-outline-sharp",
      title: "Meeting reminder: Tomorrow at 9:00 AM",
      desc: "Don't forget your meeting with the client.",
      time: "1 hour ago",
    },
    {
      icon: "material-symbols-light:checklist",
      title: "Task completed",
      desc: "The task assigned to you has been completed.",
      time: "4 hours ago",
    },
    {
      icon: "material-symbols-light:mark-unread-chat-alt-outline-sharp",
      title: "New comment on your post",
      desc: "Someone commented on your recent post.",
      time: "10 hours ago",
    },
    {
      icon: "material-symbols-light:update",
      title: "System update scheduled",
      desc: "There will be a system update tomorrow.",
      time: "Yesterday at 6:00 PM",
    },
  ];

  const toggleAppSidebarDesktop = () => {
    var elm = document.querySelector(".app");
    if (elm) {
      if (
        !(
          elm.classList.contains("app-with-top-nav") &&
          elm.classList.contains("app-without-sidebar")
        )
      ) {
        elm.classList.toggle("app-sidebar-collapsed");

        // Sincronizamos el estado con la clase real
        const collapsed = elm.classList.contains("app-sidebar-collapsed");
        setAppSidebarCollapsed(collapsed);

        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 150);
      }
    }
  };

  const toggleAppSidebarMobile = () => {
    var elm = document.querySelector(".app");
    if (elm) {
      if (
        !(
          elm.classList.contains("app-with-top-nav") &&
          elm.classList.contains("app-without-sidebar")
        )
      ) {
        const isMobileToggled = elm.classList.toggle(
          "app-sidebar-mobile-toggled",
        );
        setAppSidebarMobileToggled(isMobileToggled);
        //elm.classList.toggle("app-sidebar-mobile-toggled");
      } else {
        slideToggle(document.querySelector(".app-top-nav"));
      }
    }
  };

  const toggleAppHeaderSearch = () => {
    var elm = document.querySelector(".app");
    elm.classList.toggle("app-header-menu-search-toggled");
  };

  const toggleAppThemePanel = (event) => {
    event.preventDefault();

    var state =
      appThemePanelToggled === "true" || appThemePanelToggled === true
        ? false
        : true;

    setAppThemePanelToggled(state);
    if (localStorage) {
      localStorage.setItem("appThemePanelToggled", state);
    }
  };

  return (
    <div id="header" className="app-header">
      <div className="desktop-toggler">
        <button
          type="button"
          className="menu-toggler"
          onClick={toggleAppSidebarDesktop}
        >
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>

      <div className="mobile-toggler">
        <button
          type="button"
          className="menu-toggler"
          onClick={toggleAppSidebarMobile}
        >
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>

      <div className="brand">
        <Link to="/" className="brand-logo w-100 d-flex align-items-center">
          <img
            src="/assets/img/babilonia2.png"
            alt="Babilonia"
            className="me-2"
            style={{
              width: "32px",
              height: "32px",
              objectFit: "contain",
              display: "block",
            }}
          />
          <span className="brand-text fw-600 fs-15px">BABILONIA</span>
        </Link>
      </div>

      <div className="menu">
        <div className="menu-item dropdown d-lg-flex d-none me-3">
          <div className="menu-search-inline">
            <span className="menu-icon">
              <Icon icon="ph:magnifying-glass-duotone" />
            </span>
            <input
              className="form-control"
              placeholder="Busca algo..."
              defaultValue=""
              name="keywords"
            />
          </div>
        </div>
        <div className="menu-item dropdown d-lg-none d-flex">
          <a
            href="#/"
            className="menu-link menu-link-icon"
            onClick={toggleAppHeaderSearch}
          >
            <Icon icon="ph:magnifying-glass-duotone" className="menu-icon" />
          </a>
        </div>

        <div className="menu-item dropdown dropdown-mobile-full">
          <a
            href="#/"
            data-bs-toggle="dropdown"
            data-bs-display="static"
            className="menu-link menu-link-icon"
          >
            <Icon icon="ph:chats-duotone" className="menu-icon" />
          </a>
          <div className="dropdown-menu dropdown-menu-end fade p-0 w-300px">
            <div className="card">
              <div className="card-header with-btn">DISCUSSION GROUP</div>

              <PerfectScrollbar
                className={`card-body fs-10px ${
                  chatData && chatData.length ? "h-200px" : ""
                }`}
              >
                <div className="widget-chat">
                  {chatData && chatData.length > 0 ? (
                    chatData.map((chat, chatIndex) =>
                      chat.date ? (
                        <div className="widget-chat-date" key={chatIndex}>
                          {chat.date}
                        </div>
                      ) : (
                        <div
                          className={`widget-chat-item ${
                            chat.reply ? "reply" : ""
                          }`}
                          key={chatIndex}
                        >
                          {chat.img && (
                            <div className="widget-chat-media">
                              <img src={chat.img} alt="" />
                            </div>
                          )}
                          <div className="widget-chat-content">
                            {chat.name && (
                              <div className="widget-chat-name">
                                {chat.name}
                              </div>
                            )}
                            {chat.msg &&
                              chat.msg.map((msg, msgIndex) => (
                                <div
                                  className={`widget-chat-message ${
                                    msgIndex === chat.msg.length - 1
                                      ? "last"
                                      : ""
                                  }`}
                                  key={msgIndex}
                                >
                                  {msg}
                                </div>
                              ))}
                          </div>
                        </div>
                      ),
                    )
                  ) : (
                    <div className="widget-chat-item">No records found</div>
                  )}
                </div>
              </PerfectScrollbar>
            </div>

            {chatData && chatData.length > 0 && (
              <Link
                className="dropdown-item fs-10px text-center py-2 d-block"
                to="/messenger"
              >
                VIEW ALL
              </Link>
            )}
          </div>
        </div>

        <div className="menu-item dropdown dropdown-mobile-full">
          <a
            href="#/"
            data-bs-toggle="dropdown"
            data-bs-display="static"
            className="menu-link menu-link-icon"
          >
            <Icon icon="ph:squares-four-duotone" className="menu-icon" />
          </a>
          <div className="dropdown-menu fade dropdown-menu-end p-0 w-300px text-center">
            <div className="row row-grid gx-0">
              <div className="col-4">
                <Link
                  to="/analytics"
                  className="dropdown-item text-decoration-none p-3 bg-none"
                >
                  <div className="position-relative">
                    <div className="menu-icon">
                      <Icon icon="material-symbols:home" />
                    </div>
                  </div>
                  <div className="fw-500 fs-10px text-white">INICIO</div>
                </Link>
              </div>
              <div className="col-4">
                <Link
                  to="/dashboard"
                  target="_blank"
                  className="dropdown-item text-decoration-none p-3 bg-none"
                >
                  <div>
                    <div className="menu-icon">
                      <Icon icon="ph:pencil-simple-duotone" />
                    </div>
                  </div>
                  <div className="fw-500 fs-10px text-white">LEADS</div>
                </Link>
              </div>
              <div className="col-4">
                <Link
                  to="/form/wizards"
                  className="dropdown-item text-decoration-none p-3 bg-none"
                >
                  <div>
                    <div className="menu-icon">
                      <Icon icon="ph:stack-duotone" />
                    </div>
                  </div>
                  <div className="fw-500 fs-10px text-white">VENTAS</div>
                </Link>
              </div>
            </div>
            <div className="row row-grid gx-0">
              <div className="col-4">
                <Link
                  to="/deals/detail"
                  className="dropdown-item text-decoration-none p-3 bg-none"
                >
                  <div>
                    <div className="menu-icon">
                      <Icon icon="mdi:tag" />
                    </div>
                  </div>
                  <div className="fw-500 fs-10px text-white">DEALS</div>
                </Link>
              </div>
              <div className="col-4">
                <Link
                  to="/deals/request"
                  className="dropdown-item text-decoration-none p-3 bg-none"
                >
                  <div className="position-relative">
                    <div className="menu-icon">
                      <Icon icon="mdi:frequently-asked-questions" />
                    </div>
                  </div>
                  <div className="fw-500 fs-10px text-white">SOLICITUDES</div>
                </Link>
              </div>
              <div className="col-4">
                <Link
                  to="/pos/customer-order"
                  className="dropdown-item text-decoration-none p-3 bg-none"
                >
                  <div>
                    <div className="menu-icon">
                      <Icon icon="mdi:car" />
                    </div>
                  </div>
                  <div className="fw-500 fs-10px text-white">INVENTARIO</div>
                </Link>
              </div>
              <div className="col-4">
                <Link
                  to="/pos/customer-order-v2"
                  className="dropdown-item text-decoration-none p-3 bg-none"
                >
                  <div>
                    <div className="menu-icon">
                      <Icon icon="mdi:car" />
                    </div>
                  </div>
                  <div className="fw-500 fs-10px text-white">INVENTARIO</div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="menu-item dropdown dropdown-mobile-full">
          <a
            href="#/"
            data-bs-toggle="dropdown"
            data-bs-display="static"
            className="menu-link menu-link-icon"
          >
            <Icon icon="ph:warning-duotone" className="menu-icon" />
          </a>
          <div className="dropdown-menu dropdown-menu-end fade w-300px p-0">
            <h6 className="dropdown-header fw-semibold py-2">NOTIFICATIONS</h6>
            {notificationData && notificationData.length > 0 ? (
              <>
                {notificationData.map((notification, index) => (
                  <a
                    href="#/"
                    key={index}
                    className="dropdown-item d-flex align-items-center fs-10px"
                  >
                    <div>
                      <div className="w-40px h-40px bg-white bg-opacity-10 text-white fs-30px d-flex align-items-center justify-content-center">
                        <Icon icon={notification.icon} />
                      </div>
                    </div>
                    <div className="flex-1 ps-3 text-truncate">
                      <div className="text-white fw-semibold">
                        {notification.title}
                      </div>
                      <div className="text-white text-opacity-75">
                        {notification.desc}
                      </div>
                      <div className="text-white text-opacity-50 small">
                        {notification.time}
                      </div>
                    </div>
                  </a>
                ))}
                <Link
                  className="dropdown-item fs-10px text-center py-2 d-block"
                  to="/messenger"
                >
                  VIEW ALL
                </Link>
              </>
            ) : (
              <div className="small p-3 bg-white bg-opacity-15">
                No records found
              </div>
            )}
          </div>
        </div>

        <div className="menu-item dropdown dropdown-mobile-full">
          <a
            href="#/"
            data-bs-toggle="dropdown"
            data-bs-display="static"
            className="menu-link d-flex align-items-center"
          >
            <div className="menu-img online me-sm-2 ms-lg-0 ms-n2">
              {userData.img ? (
                <img src={userData.img} alt="Profile" className="" />
              ) : (
                <div className="d-flex align-items-center justify-content-center w-100 h-100 bg-white bg-opacity-25 text-white text-opacity-50 rounded-circle overflow-hidden">
                  <i className="bi bi-person-fill fs-24px mb-n3"></i>
                </div>
              )}
            </div>
            <div className="menu-text d-sm-block d-none">
              <span className="d-block">
                <span>{userData.name}</span>
              </span>
            </div>
          </a>
          <div className="dropdown-menu dropdown-menu-end me-lg-3 fs-10px fade">
            <h6 className="dropdown-header">OPCIONES</h6>
            <Link className="dropdown-item" to="#" onClick={handleLogout}>
              CERRAR SESIÓN
            </Link>
            <Link
              className="dropdown-item"
              to="#"
              onClick={() => setShowPasswordModal(true)}
            >
              CONTRASEÑA
            </Link>
          </div>
        </div>
      </div>

      <form className="menu-search-float" name="header_search_form">
        <div className="menu-search-container">
          <div className="menu-search-icon">
            <i className="bi bi-search"></i>
          </div>
          <div className="menu-search-input">
            <input
              type="text"
              className="form-control"
              defaultValue=""
              placeholder="Busca algo..."
            />
          </div>
          <div className="menu-search-icon">
            <a href="#/" onClick={toggleAppHeaderSearch}>
              <i className="bi bi-x-lg"></i>
            </a>
          </div>
        </div>
      </form>
      {showPasswordModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Cambiar contraseña</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPasswordModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row mb-4">
                  <div className="col-md-12 mb-3">
                    <label className="form-label fs-5">
                      Contraseña actual <span className="text-danger">*</span>
                    </label>
                    <div className="position-relative">
                      <input
                        type={showCurrentPassword ? "text" : "password"}
                        name="contrasena_actual"
                        className="form-control form-control-lg fs-14px"
                        value={formData.contrasena_actual}
                        onChange={handleChange}
                        placeholder="Ingresa tu contraseña actual"
                        required
                      />
                      <i
                        className={`bi ${showCurrentPassword ? "bi-eye-slash" : "bi-eye"} ojito-icon-1`}
                        onClick={() =>
                          setShowCurrentPassword(!showCurrentPassword)
                        }
                      ></i>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fs-5">
                      Contraseña <span className="text-danger">*</span>
                    </label>
                    <div className="position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="contrasena"
                        className="form-control form-control-lg fs-14px"
                        value={formData.contrasena}
                        onChange={handleChange}
                        placeholder="Nueva contraseña"
                        required
                      />
                      <i
                        className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} ojito-icon-1`}
                        onClick={() => setShowPassword(!showPassword)}
                      ></i>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fs-5">
                      Confirmar Contraseña{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="position-relative">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmar_contrasena"
                        className="form-control form-control-lg fs-14px"
                        value={formData.confirmar_contrasena}
                        onChange={handleChange}
                        placeholder="Confirma tu contraseña"
                        required
                      />
                      <i
                        className={`bi ${
                          showConfirmPassword ? "bi-eye-slash" : "bi-eye"
                        } ojito-icon-1`}
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowPasswordModal(false)}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={!isFormValid}
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
